import React from 'react'

class WhiteLabel extends React.Component {
  render() {
    return(
      <div className='whitelabel-area'>
        <b> Powered By: </b>
        <div className='whitelabel-img'>
          <img src="leavelogic-logo.png" />
        </div>
      </div>
    )
  }
}

export default WhiteLabel
